import { Component, OnDestroy, OnInit } from "@angular/core";
import { Company } from "../../../models/company";
import { Location } from "../../../models/location";
import { Tablet } from "../../../models/tablet";

import { AuthService } from "../../../services/auth.service";
import { CompanyService } from "../../../services/company.service";
import { CustomerTypeService } from "../../../services/customer-type.service";
import { LocationService } from "../../../services/location.service";
import { NavigationEnd, Router } from "@angular/router";

import { saveAs as importedSaveAs } from "file-saver";

import * as moment from "moment";
import { Page } from "../../../models/paging/page";
import { Customer_Type } from "../../../models/customer_Type";
import { AuditReportService } from "../../../services/audit-report.service";
import { ColumnService } from "../../../services/ColumnService";
import { Subscription } from "rxjs";

@Component({
  selector: "app-audit-report",
  templateUrl: "./audit-report.component.html",
  styleUrls: ["./audit-report.component.css"],
})
export class AuditReportComponent implements OnInit, OnDestroy {
  companyService: CompanyService;
  locationService: LocationService;

  customerTypes: Customer_Type[];
  users: Tablet[];

  companies: Company[];
  companyList: Company[];

  locations: Location[];
  locationList: Location[];
  showCalendars: boolean = true;

  filter: any = {
    customer_Type_Id: 0,
    company_Id: 0,
    location_Id: 0,
    pda_User_ID: 0,
    start_Date: moment().toDate(),
    end_Date: moment().toDate(),
    quick_Search: "",
  };

  availableOptions: string[] = [
    "Date",
    "Customer",
    "Account #",
    "Location Address",
    "Postcode",
    "Customer Type",
    "User",
    "# of Cyls",
  ];

  selectedOptions: string[] = [
    "Date",
    "Customer",
    "Account #",
    "Location Address",
    "Postcode",
    "Customer Type",
    "User",
    "# of Cyls",
  ];

  viewtype: 0;
  page = new Page();
  rows = Array<any>();
  init: boolean;
  is_client = false;
  client;

  showPopup: boolean = false;
  popupContent: string = "";
  private routerEventsSubscription: Subscription;

  constructor(
    authService: AuthService,
    companyService: CompanyService,
    locationService: LocationService,
    public auditReportService: AuditReportService,
    customerTypeService: CustomerTypeService,
    public router: Router,
    private columnService: ColumnService
  ) {
    this.is_client = authService.currentUser.value.userType == 0;
    this.client = authService.currentUser.value;
    
    this.page.pageNumber = 0;
    this.page.size = 10;
    this.page.sortOrder = "desc";
    this.page.sortBy = "";
    
    this.loadFiltersFromStorage();
    customerTypeService.getAll().then((data) => {
      this.customerTypes = data;
    });

    companyService.getAll(this.filter.customer_Type_Id).then((data) => {
      this.companyList = data;
      this.companies = this.companyList;
      if (this.is_client) {
        this.filter.company_Id = authService.currentUser.value.company_Id;
        this.filter.location_Id = authService.currentUser.value.location_Id;
      }

      locationService.getAll(this.filter.company_Id).then((data) => {
        this.locationList = data;
        
        if (this.filter.company_Id !== 0) {
          this.locations = this.locationList;
        }

        if (this.is_client) {
          this.locations = this.locationList.filter((c) => {
            return c.company_Id == this.filter.company_Id;
          });
        }
      });

      this.loadTable(this.page);
    });

    this.companyService = companyService;
    this.locationService = locationService;
  }

  ngOnInit() {
    this.routerEventsSubscription = this.router.events.subscribe((event) => {
        if (event instanceof NavigationEnd) {
            this.saveFiltersToStorage();
        }
    });
    this.getcolumns();
    this.loadTable(this.page);
    this.init = true;

}

ngOnDestroy() {
    if (this.routerEventsSubscription) {
        this.routerEventsSubscription.unsubscribe();
    }
    this.saveFiltersToStorage();  
}

  loadClientAuditCylsPage(row: any) {
    this.router.navigate(["reports/audit_report/cyls"], {
      queryParams: {
        client_Audit_Id: row.audit_ID,
        client: false,
      },
    });
  }

  // ###################################
  // Filters
  // ###################################
  onCustomerTypeChange(value) {
    this.filter.company_Id = 0;
    this.filter.location_Id = 0;
    this.filter.region_Id = 0;
  
    this.companyService.getAll(value).then((companies) => {
      this.companyList = companies;
      this.companies = companies;
  
      this.locations = [];
    });
  }
  
  onCompanyChange(value) {
    this.filter.location_Id = 0;
    this.filter.region_Id = 0;
  
    if (Number(value) === 0) {
      this.locations = [];
      return;
    }
  
    this.locationService.getAll(value).then((locations) => {
      this.locationList = locations;
      this.locations = locations;
    });
  }

  // ###################################
  // TABLE
  // ###################################
  setPage(pageInfo) {
    this.page.pageNumber = pageInfo.offset;
    this.loadTable(this.page);
  }

  onSort(event) {
    if (!event.column.prop) {
      return false;
    }

    const sortMapping = {
      starttime_Display: "starttime_Sorting",
      user: "firstname",
    };

    const sortOrder = event.newValue;
    const sortBy = sortMapping[event.column.prop] || event.column.prop;

    this.page.sortOrder = sortOrder;
    this.page.sortBy = sortBy;

    this.loadTable(this.page);
  }

  loadTable(page: Page) {
    this.auditReportService
      .getResults(
        this.page,
        this.filter.customer_Type_Id,
        this.filter.company_Id,
        this.filter.location_Id,
        this.filter.pda_User_ID,
        this.filter.start_Date,
        this.filter.end_Date,
        this.is_client,
        this.filter.quick_Search
      )
      .then((pagedData) => {
        this.page = pagedData.page;
        this.rows = pagedData.data;

        if (this.init) {
          this.gotoTop();
          this.init = false;
        }
      });
  }

  onRefresh() {
    this.page.pageNumber = 0;
    this.loadTable(this.page);
  }

  generateExcel() {
    this.auditReportService
      .getExcel(
        this.filter.customer_Type_Id,
        this.filter.company_Id,
        this.filter.location_Id,
        this.filter.pda_User_ID,
        this.filter.start_Date,
        this.filter.end_Date,
        this.is_client
      )
      .then((data) => {
        importedSaveAs(data, "Distributions.xlsx");
      });
  }

  gotoTop() {
    // window.scrollTo(-9999,-99999);
    let top = document.getElementById("top");
    if (top !== null) {
      top.scrollIntoView(true);
      //  document.getElementById("top").scrollTop -= 99999;
      top = null;
    }
  }

  handleSelectedColumns(selectedOptions: string[]): void {
    this.selectedOptions = selectedOptions;
    this.saveSelection();
  }

  getcolumns() {
    this.columnService
      .getColumns(this.client.userId, "auditReport")
      .then((data) => {
        if (data.columns != null) {
          this.selectedOptions = this.availableOptions.filter((c) => {
            return data.columns.includes(c);
          });
        }
      });
  }

  saveSelection() {
    this.columnService
      .save(this.client.userId, "auditReport", this.selectedOptions)
      .then((data) => {});
  }

  saveFiltersToStorage() {
    localStorage.setItem('auditReportFilters', JSON.stringify(this.filter));
  }

  loadFiltersFromStorage() {
    const savedFilters = localStorage.getItem('auditReportFilters');
    if (savedFilters) {
        this.filter = JSON.parse(savedFilters);
        this.filter.start_Date = moment(this.filter.start_Date).toDate();
        this.filter.end_Date = moment(this.filter.end_Date).toDate();
    }
  }

  resetFilters() {
      this.filter.customer_Type_Id = 0;
      this.filter.company_Id = 0;
      this.filter.location_Id = 0;
      this.filter.pda_User_ID = 0;
      this.filter.quick_Search = '';
      
        
      // Forcefully re-render date pickers
      this.showCalendars = false;
        
      setTimeout(() => {
        const today = moment().toDate();
        this.filter.start_Date = today;
        this.filter.end_Date = today;
    
        this.showCalendars = true;
      });
    
      localStorage.removeItem('auditReportFilters');
      this.loadTable(this.page);
    
    }

}
